// extracted by mini-css-extract-plugin
export default {"container":"CustomControl_container__KMYux"};